<script>
    import registrationTypes from '../config/registrationTypes';

    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';
    import ClaimantSomeoneElse from './ClaimantSomeoneElse.svelte';
    import ClaimantDeceasedEstate from './ClaimantDeceasedEstate.svelte';

    export let disabled = null;
    export let registrationType;
    export let claimant;
    export let groupMemberInformation;

</script>


<FormRow>
    <FormColumn>
        <h2>Claimant Details</h2>
    </FormColumn>
</FormRow>
	
<hr class="primary" />

{#if registrationType == registrationTypes.types.SomeoneElse.value}
    <ClaimantSomeoneElse {disabled} bind:claimant />
{:else}
    <ClaimantDeceasedEstate
        {disabled}
        bind:groupMemberInformation
        bind:claimant />
{/if}
